import Urls from '../urls.js';
import { fetch_status, fetch_json, fetch_error } from '../../../../scripts/utils/fetch.js';
import ModalView from '../../../../scripts/utils/modal-view.js';

export default class ProductAskQuestionView extends ModalView {
	constructor({ el, modal_selector, customer, navigation }) {
		super({ el, modal_selector, navigation });
		this.template_url = Urls.Templates.app;
		this.customer = customer;
		this.site_settings = window.SiteSettings || {};
		this.render();
	}

	after_render() {
		this.once_rendered();
		this.initSelectors();
	}

	get_context() {
		return {
			customer: this.customer,
			navigation: this.navigation
		};
	}

	initSelectors() {
		this.removeListeners();
		this.submit_btn = this.modal.querySelector('[type="submit"]');
		this.cancel_btn = this.modal.querySelector('.js-cancel');
		this.content = this.modal.querySelector('.modal-content');
		this.fields = this.el.querySelectorAll('.form-control');
		this.addListeners();
	}

	addListeners () {
		this.submit_btn.addEventListener('click', this.submit.bind(this));
		this.cancel_btn.addEventListener('click', this.close.bind(this));

		this.fields.forEach(input => {
			['change', 'paste', 'keyup'].forEach(evt_name => {
				input.addEventListener(evt_name, this.validate.bind(this));
			});
		});
	}

	removeListeners () {
		if (this.cancel_btn) {
			this.cancel_btn.removeEventListener('click', this.close.bind(this));
		}
		if (this.fields) {
			['change', 'keyup', 'paste'].forEach(evt_name => {
				this.fields.removeEventListener(evt_name, this.validate.bind(this));
			});
		}
	}

	get_data () {
		return {
			customer_id: this.customer.cid,
			question_email: this.getElementValue('[name="question_email"]'),
			question_body: this.getElementValue('[name="question_body"]')
		};
	}

	getElementValue (selector) {
		const element = this.modal.querySelector(selector);
		if (element) {
			return element.value;
		}
		return null;
	}

	validate () {
		let is_valid = true;
		const data = this.get_data();

		is_valid = !!data.question_body.length &&
			( ( data.question_email && data.question_email.indexOf( '@' ) > 0 ) || data.customer_id );

		if (is_valid) {
			this.submit_btn.removeAttribute('disabled');
		} else {
			this.submit_btn.setAttribute('disabled', 'disabled');
		}
	}

	submit () {
		if (this.site_settings.USE_RECAPTCHA_FOR_FORMS && this.site_settings.RECAPTCHA_SITE_KEY.length && grecaptcha) {
			grecaptcha.ready(function () {
				grecaptcha.execute(this.site_settings.RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function (token) {
					this.submitQuestion(token);
				}.bind(this));
			}.bind(this));
		} else {
			this.submitQuestion();
		}
	}

	submitQuestion (g_recaptcha_response) {
		const url = Urls.Api.question(window.Session.product_id);
		const data = this.get_data();

		if (g_recaptcha_response) {
			data.g_recaptcha_response = g_recaptcha_response;
		}

		fetch(url, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(fetch_status)
			.then(fetch_json)
			.then(json => {
				this.content.innerHTML = '<p>Thank you! Your question has been sent.</p>';
			})
			.catch(error => {
				fetch_error(error, true)
					.then(error_json => {
						let message = 'Something went wrong...';
						if (error_json && typeof error_json === 'object') {
							message = typeof error_json.responseJSON.Message === 'undefined' ? error_json.Message : error_json.responseJSON.Message;
						}
						this.content.innerHTML = `<p>Could not add question.<br>${message}</p>`;
					});
				});
	}

}
